/**
 * Global Home-map teardown hook (set by the active Command Map instance on `#/overview`).
 * Filename ``ops-map-teardown`` is historical KEEP helper naming (ZD-DEAD) — not a `#/ops-map` route.
 */

export function runGlobalOpsMapTeardownIfAny() {
  if (typeof window === "undefined") return;
  if (typeof window.__opsMapTeardown === "function") {
    try {
      window.__opsMapTeardown();
    } catch (_) {}
    window.__opsMapTeardown = null;
  }
}
